import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { getBackgroundColor as n } from "./spec-util.js";
import { stylable as r } from "../decorators/stylable.js";
import "../decorators.js";
//#region src/specs/nodes/table-spec.ts
var i = ["true", "false"], a = (e, t) => t ? e.concat(t, ";") : "", o = (e) => ({
	paddingTop: e.style?.paddingTop,
	paddingBottom: e.style?.paddingBottom,
	paddingLeft: e.style?.paddingLeft,
	paddingRight: e.style?.paddingRight,
	backgroundColor: n(e.style?.backgroundColor),
	colwidth: e.getAttribute("data-colwidth") ? [Number(e.getAttribute("data-colwidth"))] : null
}), s = r({
	content: "tableRow+",
	tableRole: "table",
	isolating: !0,
	attrs: t({
		type: { default: "table" },
		responsive: { default: !1 },
		container: { default: !1 },
		stacked: { default: void 0 },
		sectionType: { default: void 0 },
		backgroundColor: { default: "" }
	}),
	parseDOM: [{
		tag: "table",
		getAttrs(e) {
			return {
				responsive: e.getAttribute("data-responsive") !== null,
				stacked: i.includes(e.attributes["data-stacked"]) ? e.attributes["data-stacked"] : !0,
				container: e.getAttribute("data-container") !== null,
				sectionType: e.getAttribute("data-section-type") ?? void 0,
				backgroundColor: n(e.style?.backgroundColor)
			};
		}
	}],
	toDOM(t) {
		if (t.attrs.container) {
			let n = t.attrs, r = n.sectionType ?? "";
			return [
				"div",
				{ class: `${e.blockContainer} ${e.table} embercom-prosemirror-composer-section` },
				[
					"div",
					{ class: "section-type" },
					r
				],
				[
					"table",
					{
						class: "container intercom-template-content",
						"data-container": "true",
						"data-section-type": r,
						style: `${a("background-color: ", n.backgroundColor ?? "")}`
					},
					["tbody", 0]
				]
			];
		}
		return t.attrs.responsive ? [
			"div",
			{ class: `${e.blockContainer} ${e.table} embercom-prosemirror-composer-layout` },
			[
				"table",
				{
					class: "row intercom-responsive-layout-table",
					"data-responsive": "true",
					"data-stacked": typeof t.attrs.stacked == "boolean" ? t.attrs.stacked.toString() : ""
				},
				["tbody", 0]
			]
		] : [
			"div",
			{ class: `${e.blockContainer} ${e.table}` },
			["table", ["tbody", 0]]
		];
	}
}), c = {
	content: "tableCell+",
	tableRole: "row",
	parseDOM: [{ tag: "tr" }],
	toDOM() {
		return ["tr", 0];
	}
}, l = r({
	content: "(block | list)+",
	tableRole: "cell",
	isolating: !0,
	parseDOM: [{
		tag: "td",
		getAttrs(e) {
			return o(e);
		}
	}, {
		tag: "th",
		getAttrs(e) {
			return o(e);
		}
	}],
	attrs: t({
		colspan: { default: 1 },
		rowspan: { default: 1 },
		colwidth: { default: null },
		responsiveClasses: { default: "" },
		container: { default: !1 }
	}),
	toDOM(e) {
		let t = e.attrs;
		return e.attrs.responsiveClasses ? [
			"td",
			{
				"data-insertable": "true",
				class: t.responsiveClasses
			},
			0
		] : [
			"td",
			{
				"data-insertable": "true",
				"data-colwidth": t.colwidth?.[0] ?? null ?? void 0
			},
			0
		];
	}
});
//#endregion
export { l as tableCellSpec, c as tableRowSpec, s as tableSpec };
